import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  SEARCH_FILTERS_LIST_START: "SEARCH_FILTERS_LIST_START",
  SEARCH_FILTERS_LIST_SUCCESS: "SEARCH_FILTERS_LIST_SUCCESS",
  SEARCH_FILTERS_LIST_FAILED: "SEARCH_FILTERS_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const searchFiltersListStart = (data) => ({
  type: actionType.SEARCH_FILTERS_LIST_START,
  payload: data,
});

export const searchFiltersListSuccess = (data) => ({
  type: actionType.SEARCH_FILTERS_LIST_SUCCESS,
  payload: data,
});

export const searchFiltersListFailed = (data) => ({
  type: actionType.SEARCH_FILTERS_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function searchFiltersListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.SEARCH_FILTERS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.SEARCH_FILTERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.SEARCH_FILTERS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* searchFiltersListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      const allSearchfilters = response.data.data.allSearchfilters.Searchfilters
        ? response.data.data.allSearchfilters.Searchfilters
        : null;
      let finaldata = [];
      
      if (allSearchfilters && allSearchfilters.length) {
        for (const iterator of allSearchfilters) {
          let tempData = { ...iterator };
          if (
            tempData.serchfiltermappingserachfilterIdMap &&
            tempData.serchfiltermappingserachfilterIdMap.Serchfiltermappings && 
            tempData.serchfiltermappingserachfilterIdMap.Serchfiltermappings.length
          ) {
            tempData["filterData"] = tempData.serchfiltermappingserachfilterIdMap.Serchfiltermappings;
          }
          const {serchfiltermappingserachfilterIdMap,...restData} = tempData;
          finaldata = [restData,...finaldata]
        }
      }
      yield put(searchFiltersListSuccess(finaldata));
    } else {
      messagePopup("", "Search Filters List failed", "error");
      yield put(searchFiltersListFailed("Search Filters List failed"));
    }
  } catch (error) {
    messagePopup("", "Search Filters List failed", "error");
    yield put(searchFiltersListFailed("Search Filters List failed"));
  }
}

export function* watchSearchFiltersListSaga() {
  yield takeEvery(actionType.SEARCH_FILTERS_LIST_START, searchFiltersListSaga);
}
